const BASEURL =
  "https://cors-anywhere.herokuapp.com/https://futurecodersse.pythonanywhere.com/api/";
//"https://futurecodersse.pythonanywhere.com/api/;"
// here the future API end point
export default BASEURL;
